<template>
    <div class="tabbar">
        <router-link
                v-for="router in routers"
                :key="router.path"
                class="tabbar-item"
                :to="router.path"
                exact replace>
            <img class="tabbar-item-icon" :src="$route.path === router.path ? router.icon : router.normal" alt="">

            <span class="tabbar-item-label">
                {{router.name}}
            </span>

        </router-link>
    </div>
</template>
<script>
    export default {
        name: 'TabBar',
        props: {
            routers: {
                type: Array,
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import "../assets/scss/variables";
    @import "../assets/scss/flex";

    $bar-tab-height: 56px;
    .tabbar {
        right: 0;
        bottom: 0;
        left: 0;
        position: fixed;
        z-index: 1;
        text-align: center;
        background-color: #f7f7f7;
        border-top: 1px solid #eee;
        @include flexbox;
        -webkit-touch-callout: none; //选项卡上禁止长按弹出菜单；
        .tabbar-item {
            display: block;
            padding: 3px 0;
            @include flex(1);

            &.router-link-exact-active, &.router-link-active {
                color: #75b1f8;
            }

            // Tab icon
            .tabbar-item-icon {
                display: inline-block;
                position: relative;
                top: 6px;
                /*width: 20px;*/
                height: 20px;
                text-align: center;
                padding-top: 0;
                padding-bottom: 0;
                background-size: cover;
                // Make the text smaller if it's used with an icon
                ~ .tabbar-item-label {
                    display: block;
                    font-size: 11px;
                    //处理超出部分文字；
                    overflow: hidden;
                    margin-top: 5px;
                    text-overflow: ellipsis;
                }

                &:active {
                    background: none;
                }
            }
        }
    }


    @media screen and (max-width: 320px){
        .tabbar {
            .tabbar-item {

                // Tab icon
                .tabbar-item-icon {
                    // Make the text smaller if it's used with an icon
                    ~ .tabbar-item-label {
                        font-size: 10px;
                    }
                }
            }
        }
    }
</style>